import { httpService } from '@/api/v1/http.service'
import { type DownloadParams, useDownload } from '@/hooks/useDownload'
import { getOrdering } from '@/utils/get-ordering'
import { parseColumnsToFetchKeys } from '@/utils/parse-columns-to-fetch-keys'

import { type StudentAbsenceParams } from '../queries/useStudentAbsences'

type Params = DownloadParams & StudentAbsenceParams

const useAbsencesDownload = (absencesDownloadParams: Params) =>
  useDownload({
    fileName: 'absences_all',
    requestParams: absencesDownloadParams,
    // @ts-expect-error Waits for backend fix - file type should be returned
    downloadMutation: (params: Params) =>
      httpService.panel.panelAbsencesSummaryRetrieve(
        {
          format: params.format,
          class_id: params.classId,
          student_id: params.studentId,
          semester_id: params.semester,
          ordering: getOrdering(params),
          fetchKeys: parseColumnsToFetchKeys(params.columnsKey, params.format)
        },
        { format: 'blob' }
      )
  })

export default useAbsencesDownload
